import { getFloat } from '../../../../../helper'

export const validatePrice = (value, { t, isBottleDeposit }) => {
	const str = String(value ?? '').trim()

	if (!str) return { error: t('app.validation.required') }

	const numberRe = /^-?\d+(?:,\d+)*(?:\.\d+)?$/
	if (!numberRe.test(str)) return { error: t('app.validation.number') }

	const numeric = getFloat(str)
	if (!isBottleDeposit && numeric < 0) {
		return { error: t('app.validation.greaterThenZero') }
	}

	return { error: '', numeric }
}
